var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGWolontariat = function SvgGWolontariat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 155.5 210.86"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".g_wolontariat_svg__cls-2{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g_wolontariat_svg__Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h155.5v155.5H0zM0 155.5h155.5V311H0z",
    className: "g_wolontariat_svg__cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h155.5v155.5H0z",
    className: "g_wolontariat_svg__cls-2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g_wolontariat_svg__Warstwa_1",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.01 69.84v-21.8c-30.8 0-53.18 22-53.18 52.03s22.38 52.05 53.18 52.05V130.3c-16.27 0-28.89-11.67-28.89-30.23s12.62-30.23 28.89-30.23",
    style: {
      fill: "#091f2c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.82 106.54c.24-2.1.38-4.27.38-6.47s-.14-4.4-.39-6.51c-1.91-16.23-10.97-29.58-23.9-37.53-8.31-5.11-18.23-7.99-28.9-7.99v21.8c16.27 0 28.9 12.44 28.9 30.23s-12.63 30.23-28.9 30.23v21.82c10.67 0 20.59-2.88 28.9-7.95v3.09h-.04v19.25c0 10.96-8.92 19.87-19.87 19.87H65.19v24H111c24.19 0 43.87-19.68 43.87-43.87v-19.25h-.05z",
    style: {
      fill: "#98a4ff"
    }
  })));
};
export default SvgGWolontariat;